import { ReactNode } from 'react';

import { Typography as Text } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--encore-spacing-tighter-2)',
    padding: 'var(--encore-spacing-tighter-2) var(--encore-spacing-tighter)',
    border: '1px solid var(--essential-subdued)',
    borderRadius: 'var(--encore-corner-radius-base)',
  },
  icon: {
    marginTop: 2,
    flexShrink: 0,
    color: 'var(--text-subdued)',
    display: 'inline-flex',
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
});

export type ChatInformationBoxProps = {
  title: ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  className?: string;
};

export const ChatInformationBox = ({
  title,
  icon,
  children,
  className,
}: ChatInformationBoxProps) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)}>
      {icon ? (
        <span className={classes.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <div className={classes.content}>
        {typeof title === 'string' ? (
          <Text variant="body2">{title}</Text>
        ) : (
          title
        )}
        {children}
      </div>
    </div>
  );
};
